<template>
  <div class=''>
      <Header :widthmun='windowWidth'/>

      <div class="new_box">
          <div class="container sp">
              <el-row>
                  <el-col :span="24">
                      <div class="col_list">
                          <el-breadcrumb separator="/">
                            <el-breadcrumb-item :to="{ path: '/' }">{{$t('home.home')}}</el-breadcrumb-item>
                            <el-breadcrumb-item>{{$t('acname.title')}}</el-breadcrumb-item>
                            <el-breadcrumb-item>{{mename}}</el-breadcrumb-item>
                          </el-breadcrumb>
                      </div>
                      <h2 class="showtitle" v-html="mename"></h2>
                  </el-col>
              </el-row>
            
          </div>
      </div>

        <div class="content">
            <div class="container newcont">
                <el-row>
                    <el-col>
                        <div class="cont_box">

                            <el-row>

                                <el-col style="background: #fff;" v-if="windowWidth>=980&&flagipadbool=='1'" class="el-col-box" :xs="24" :sm="24" :md="8" :lg="7" :xl="7" >
                                    <el-collapse v-model="activeName" accordion>
                                        <el-collapse-item :class="activeName=='1'?'activeheader':''" :title="$t('acname.title1')" name="1">
                                            <div>
                                                <el-link :underline="false" :class="activeclass=='1'?'active':''" @click="changemenu($t('acname.mename1'),'1')">{{$t('acname.mename1')}}</el-link>
                                                <el-link :underline="false" :class="activeclass=='2'?'active':''" @click="changemenu($t('acname.mename2'),'2')">{{$t('acname.mename2')}}</el-link>
                                                <el-link :underline="false" :class="activeclass=='3'?'active':''" @click="changemenu($t('acname.mename3'),'3')">{{$t('acname.mename3')}}</el-link>
                                                <el-link :underline="false" :class="activeclass=='4'?'active':''" @click="changemenu($t('acname.mename4'),'4')">{{$t('acname.mename4')}}</el-link>
                                                <el-link :underline="false" :class="activeclass=='5'?'active':''" @click="changemenu($t('acname.mename5'),'5')">{{$t('acname.mename5')}}</el-link>
                                                <el-link :underline="false" :class="activeclass=='6'?'active':''" @click="changemenu($t('acname.mename6'),'6')">{{$t('acname.mename6')}}</el-link>
                                                <el-link :underline="false" :class="activeclass=='7'?'active':''" @click="changemenu($t('acname.mename7'),'7')">{{$t('acname.mename7')}}</el-link>
                                            </div>
                                        </el-collapse-item>
                                        <el-collapse-item :class="activeName=='2'?'activeheader':''" :title="$t('acname.title2')" name="2">
                                            <div v-for="(item,index) in managementList" :key="index">
                                              <div v-if="lang=='en-US'">
                                                <el-link :underline="false" :class="activeclass==item.id?'active':''" @click="changemenus(item)">{{item.titleEn}}</el-link>
                                              </div>
                                              <div v-if="lang=='zh-CN'">
                                                <el-link :underline="false" :class="activeclass==item.id?'active':''" @click="changemenus(item)">{{item.titleZh}}</el-link>
                                              </div>
                                            </div>
                                        </el-collapse-item>
                                    </el-collapse>
                                </el-col>

                                <el-col style="background: #fff;" class="cont_box_col" v-show="parmaid == '1'" :xs="24" :sm="24" :md="15" :lg="16" :xl="16" >
                                   <div>
                                       <h3>{{$t('acname.m1.c1')}}</h3>
                                       <p>{{$t('acname.m1.c2')}}</p>
                                       <p>{{$t('acname.m1.c3')}}</p>
                                   </div>
                                 </el-col>
                                 

                                 <el-col style="background: #fff;" class="cont_box_col" v-show="parmaid == '2'" :xs="24" :sm="24" :md="15" :lg="16" :xl="16" >
                                   <div>
                                       <h3>{{$t('acname.m2.c1')}}</h3>
                                       <el-row>
                                           <el-col :span="12" style="text-align:center;padding-top:10px">
                                               <i class="vision"></i>
                                               <p class="h5">{{$t('acname.m2.c2')}}</p>
                                               <p>{{$t('acname.m2.c3')}}</p>
                                           </el-col>
                                           <el-col :span="12"  style="text-align:center">
                                               <i class="mission"></i>
                                               <p class="h5">{{$t('acname.m2.c4')}}</p>
                                               <p>{{$t('acname.m2.c5')}}</p>
                                           </el-col>
                                       </el-row>
                                       <img :src="$t('acname.m2.c6')" alt="">
                                   </div>
                                 </el-col>

                                 <el-col style="background: #fff;" class="cont_box_col" v-show="parmaid == '3'" :xs="24" :sm="24" :md="15" :lg="16" :xl="16" >
                                   <div>
                                       <h3>{{$t('acname.m3.c1')}}</h3>
                                       <el-row class="ac3_box">
                                           <el-col :span="3">
                                               <img src="../../assets/img/advantages1.png" style="vertical-align: baseline;" alt="">
                                           </el-col>
                                           <el-col :span="20">
                                                <p class="h5">{{$t('acname.m3.c2')}}</p>
                                                <p>{{$t('acname.m3.c3')}}</p>
                                           </el-col>
                                       </el-row>

                                       <el-row class="ac3_box">
                                           <el-col :span="3">
                                               <img src="../../assets/img/advantages2.png" style="vertical-align: baseline;" alt="">
                                           </el-col>
                                           <el-col :span="20">
                                                <p class="h5">{{$t('acname.m3.c4')}}</p>
                                                <p>{{$t('acname.m3.c5')}}</p>
                                           </el-col>
                                       </el-row>

                                       <el-row class="ac3_box">
                                           <el-col :span="3">
                                               <img src="../../assets/img/advantages3.png" style="vertical-align: baseline;" alt="">
                                           </el-col>
                                           <el-col :span="20">
                                                <p class="h5">{{$t('acname.m3.c6')}}</p>
                                                <p>{{$t('acname.m3.c7')}}</p>
                                           </el-col>
                                       </el-row>

                                       <el-row class="ac3_box">
                                           <el-col :span="3">
                                               <img src="../../assets/img/advantages4.png" style="vertical-align: baseline;" alt="">
                                           </el-col>
                                           <el-col :span="20">
                                                <p class="h5">{{$t('acname.m3.c8')}}</p>
                                                <p>{{$t('acname.m3.c9')}}</p>
                                           </el-col>
                                       </el-row>

                                       <el-row class="ac3_box">
                                           <el-col :span="3">
                                               <img src="../../assets/img/advantages5.png" style="vertical-align: baseline;" alt="">
                                           </el-col>
                                           <el-col :span="20">
                                                <p class="h5">{{$t('acname.m3.c10')}}</p>
                                                <p>{{$t('acname.m3.c11')}}</p>
                                           </el-col>
                                       </el-row>

                                       <el-row class="ac3_box">
                                           <el-col :span="3">
                                               <img src="../../assets/img/advantages6.png" style="vertical-align: baseline;" alt="">
                                           </el-col>
                                           <el-col :span="20">
                                                <p class="h5">{{$t('acname.m3.c12')}}</p>
                                                <p>{{$t('acname.m3.c13')}}</p>
                                           </el-col>
                                       </el-row>
                                       
                                       
                                       
                                       
                                       
                                       
                                   </div>
                                 </el-col>

                                 <el-col style="background: #fff;" class="cont_box_col" v-show="parmaid == '4'" :xs="24" :sm="24" :md="15" :lg="16" :xl="16" >
                                   <div>
                                       <h3>{{$t('acname.m4.c0')}}</h3>
                                       <el-row style="padding-top:30px;padding-bottom:30px">
                                           <el-col :span="11" style="text-align:center">
                                               <img src="../../assets/img/person1.png" alt="" style='width:50%'>
                                               <p class="h5">{{$t('acname.m4.c1')}}</p>
                                               <p class="color_p">{{$t('acname.m4.c2')}}</p>
                                               <p style="text-align:left">{{$t('acname.m4.c3')}}</p>
                                               <p style="text-align:left">{{$t('acname.m4.c4')}}</p>
                                           </el-col>
                                           <el-col :span="11" :offset="1" style="text-align:center">
                                               <img src="../../assets/img/person2.png" alt="" style='width:50%'>
                                               <p class="h5">{{$t('acname.m4.c5')}}</p>
                                               <p class="color_p">{{$t('acname.m4.c6')}}</p>
                                               <p style="text-align:left">{{$t('acname.m4.c7')}}</p>
                                               <p style="text-align:left">{{$t('acname.m4.c8')}}</p>
                                           </el-col>
                                       </el-row>
                                       <el-row style="padding-top:30px;">
                                           <el-col :span="11" style="text-align:center">
                                               <img src="../../assets/img/person3.png" alt="" style='width:50%'>
                                               <p class="h5">{{$t('acname.m4.c9')}}</p>
                                               <p class="color_p">{{$t('acname.m4.c10')}}</p>
                                               <p style="text-align:left">{{$t('acname.m4.c11')}}</p>
                                               <p style="text-align:left">{{$t('acname.m4.c12')}}</p>
                                           </el-col>
                                           <el-col :span="11" :offset="1" style="text-align:center">
                                               <img src="../../assets/img/person4.png" alt="" style='width:50%'>
                                               <p class="h5">{{$t('acname.m4.c13')}}</p>
                                               <p class="color_p">{{$t('acname.m4.c14')}}</p>
                                               <p style="text-align:left">{{$t('acname.m4.c15')}}</p>
                                           </el-col>
                                       </el-row>
                                   </div>
                                 </el-col>

                                 <el-col style="background: #fff;" class="cont_box_col" v-show="parmaid == '5'" :xs="24" :sm="24" :md="15" :lg="16" :xl="16" >
                                   <div>
                                       <h3>{{$t('acname.m5.c1')}}</h3>
                                       <p>{{$t('acname.m5.c2')}}</p>
                                       <p>{{$t('acname.m5.c3')}}</p>
                                       <img :src="$t('acname.m5.c4')" alt="">
                                   </div>
                                 </el-col>

                                 <el-col style="background: #fff;" class="cont_box_col" v-show="parmaid == '6'" :xs="24" :sm="24" :md="15" :lg="16" :xl="16" >
                                   <div>
                                       <h3>{{$t('acname.m6.c1')}}</h3>
                                       <p class="h5">{{$t('acname.m6.c2')}}</p>
                                       <p>{{$t('acname.m6.c3')}}</p>
                                       <p class="h5">{{$t('acname.m6.c8')}}</p>
                                       <p>{{$t('acname.m6.c9')}}</p>
                                       <p><span class="h4">{{$t('acname.m6.c10')}}</span>{{$t('acname.m6.c11')}}</p>

                                       <p><span class="h4">{{$t('acname.m6.c12')}}</span>{{$t('acname.m6.c13')}}</p>
                                       
                                       
                                       <p>{{$t('acname.m6.c14')}}</p>

                                       <p class="li_box"><i></i>{{$t('acname.m6.c15')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c16')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c17')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c18')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c19')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c20')}}</p>

                                       <p>{{$t('acname.m6.c21')}}</p>

                                       <p class="h5">{{$t('acname.m6.c22')}}</p>

                                       <p>{{$t('acname.m6.c23')}}</p>
                                       <p>{{$t('acname.m6.c24')}}</p>
                                       <p>{{$t('acname.m6.c25')}}</p>

                                       <p class="li_box"><i></i>{{$t('acname.m6.c26')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c27')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c28')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c29')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c30')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c31')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c32')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c33')}}</p>

                                       <p>{{$t('acname.m6.c34')}}</p>
                                       <p  class="li_box"><i></i>{{$t('acname.m6.c35')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c36')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c37')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c38')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c39')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c40')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c41')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c42')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c43')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c44')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c45')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c46')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c47')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c48')}}</p>
                                       <!-- <p class="li_box"><i></i>{{$t('acname.m6.c49')}}</p> -->
                                       <p class="li_box"><i></i>{{$t('acname.m6.c50')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c51')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c52')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c53')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c54')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c55')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c56')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c57')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c58')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c59')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c60')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c61')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c62')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c63')}}</p>

                                       <p>{{$t('acname.m6.c64')}}</p>
                                       <p>{{$t('acname.m6.c65')}}</p>
                                       <p>{{$t('acname.m6.c66')}}</p>
                                       <p >{{$t('acname.m6.c67')}}</p>

                                       <p class="h5">{{$t('acname.m6.c68')}}</p>

                                       <p>{{$t('acname.m6.c69')}}</p>
                                       <p>{{$t('acname.m6.c70')}}</p>

                                       <p class="li_box"><i></i>{{$t('acname.m6.c71')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c72')}}</p>

                                       <p>{{$t('acname.m6.c73')}}</p>
                                       <p>{{$t('acname.m6.c74')}}</p>

                                       <p class="li_box"><i></i>{{$t('acname.m6.c75')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c76')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c77')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c78')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c79')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c80')}}</p>

                                       <p>{{$t('acname.m6.c81')}}<a href="https://sso.agc.gov.sg">{{$t('acname.m6.c82')}}</a></p>
                                       
                                       <p>{{$t('acname.m6.c83')}}</p>

                                       <p class="h5">{{$t('acname.m6.c84')}}</p>

                                       <p>{{$t('acname.m6.c85')}}</p>
                                       <p>{{$t('acname.m6.c86')}}<a href="#mark-1">{{$t('acname.m6.c87')}}</a></p>

                                       <p class="h5">{{$t('acname.m6.c88')}}</p>

                                       <p>{{$t('acname.m6.c89')}}</p>
                                       <p>{{$t('acname.m6.c90')}}</p>
                                       <p>{{$t('acname.m6.c91')}}</p>
                                       <p>{{$t('acname.m6.c92')}}</p>

                                       <p class="h5">{{$t('acname.m6.c93')}}</p>

                                       <p>{{$t('acname.m6.c94')}}</p>
                                       <p>{{$t('acname.m6.c95')}}</p>
                                       <p>{{$t('acname.m6.c96')}}</p>

                                       <p class="h5">{{$t('acname.m6.c97')}}</p>

                                       <p>{{$t('acname.m6.c98')}}</p>
                                       <p>{{$t('acname.m6.c99')}}</p>

                                       <p class="h5">{{$t('acname.m6.c100')}}</p>

                                       <p>{{$t('acname.m6.c101')}}</p>

                                       <p class="h5">{{$t('acname.m6.c102')}}</p>

                                       <p>{{$t('acname.m6.c103')}}</p>

                                       <p>{{$t('acname.m6.c104')}}</p>
                                       <p  class="h5">{{$t('acname.m6.c105')}}</p>

                                       <p>{{$t('acname.m6.c106')}}</p>
                                       <p class="h5">{{$t('acname.m6.c107')}}</p>

                                       <p>{{$t('acname.m6.c108')}}</p>
                                       <p>{{$t('acname.m6.c109')}}</p>

                                       <p>{{$t('acname.m6.c110')}}<a href="mailto:dpo@mvgx.com">{{$t('acname.m6.c111')}}</a></p>
                                       
                                       <p class="h5">{{$t('acname.m6.c112')}}</p>
                                       <p>{{$t('acname.m6.c113')}}</p>
                                       <p>{{$t('acname.m6.c114')}}</p>
                                       <p>{{$t('acname.m6.c115')}}</p>
                                       <p>{{$t('acname.m6.c116')}}</p>

                                       <h3>{{$t('acname.m6.c117')}}</h3>

                                       <p class="h5">{{$t('acname.m6.c118')}}</p>
                                       <p>{{$t('acname.m6.c119')}}</p>
                                       <p>{{$t('acname.m6.c120')}}</p>

                                       <p class="h5">{{$t('acname.m6.c121')}}</p>
                                       <p>{{$t('acname.m6.c122')}}</p>
                                       <p class="h5">{{$t('acname.m6.c123')}}</p>
                                       <p>{{$t('acname.m6.c124')}}</p>
                                       <p>{{$t('acname.m6.c125')}}</p>

                                       <p class="li_box"><i></i>{{$t('acname.m6.c126')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c127')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c128')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c129')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c130')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c131')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c132')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c133')}}</p>

                                       <p>{{$t('acname.m6.c134')}}</p>
                                       <p class="h5">{{$t('acname.m6.c135')}}</p>
                                       <p>{{$t('acname.m6.c136')}}</p>
                                       <p>{{$t('acname.m6.c137')}}</p>

                                       <p class="li_box"><i></i>{{$t('acname.m6.c138')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c139')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c140')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c141')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c142')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c143')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c144')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c145')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c146')}}</p>
                                       <p class="li_box"><i></i>{{$t('acname.m6.c147')}}</p>

                                       <p>{{$t('acname.m6.c148')}}</p>
                                       <p class="h5">{{$t('acname.m6.c149')}}</p>
                                       <p>{{$t('acname.m6.c150')}}</p>
                                       <p>{{$t('acname.m6.c151')}}</p>
                                       <p>{{$t('acname.m6.c152')}}</p>
                                       <p>{{$t('acname.m6.c153')}}</p>
                                       <p class="h5">{{$t('acname.m6.c154')}}</p>
                                       <p>{{$t('acname.m6.c155')}}</p>
                                       <p>{{$t('acname.m6.c166')}}</p>
                                       <p class="h5">{{$t('acname.m6.c167')}}</p>
                                       <p>{{$t('acname.m6.c168')}}</p>
                                       <p class="h5">{{$t('acname.m6.c169')}}</p>
                                       <p>{{$t('acname.m6.c170')}}</p>
                                       <p>{{$t('acname.m6.c171')}}</p>
                                       <p>{{$t('acname.m6.c172')}}<a :href="$t('acname.m6.c173')">{{$t('acname.m6.c173')}}</a></p>
                                       <p class="h5">{{$t('acname.m6.c174')}}</p>
                                       <p>{{$t('acname.m6.c175')}}</p>
                                       <p>{{$t('acname.m6.c176')}}</p>
                                       <p >{{$t('acname.m6.c177')}}</p>
                                       <p>{{$t('acname.m6.c178')}}</p>
                                   </div>
                                   <div id="mark-1">
                                       <h3>{{$t('acname.m7.c1')}}</h3>
                                       <p class="h5">{{$t('acname.m7.c2')}}</p>
                                       <p>{{$t('acname.m7.c3')}}</p>
                                       <p>{{$t('acname.m7.c4')}}</p>
                                       <p>{{$t('acname.m7.c5')}}</p>

                                       <p style="padding-right:30px">{{$t('acname.m7.c6')}}</p>
                                       <p class="h5">{{$t('acname.m7.c7')}}</p>
                                       <p>{{$t('acname.m7.c8')}}</p>
                                       <p style="padding-right:30px">{{$t('acname.m7.c9')}}</p>
                                       <p>{{$t('acname.m7.c10')}}</p>
                                       <p class="h5">{{$t('acname.m7.c11')}}</p>
                                       <p>{{$t('acname.m7.c12')}}</p>
                                       <p>{{$t('acname.m7.c13')}}</p>
                                       <p style="padding-right:30px">{{$t('acname.m7.c14')}}</p>
                                       <p>{{$t('acname.m7.c15')}}</p>
                                       <p class="h5">{{$t('acname.m7.c16')}}</p>
                                       <p>{{$t('acname.m7.c17')}}</p>
                                       <p>{{$t('acname.m7.c18')}}</p>
                                       <p>{{$t('acname.m7.c19')}}</p>
                                   </div>
                                 </el-col>

                                 <el-col style="background: #fff;" class="cont_box_col" v-show="parmaid == '7'" :xs="24" :sm="24" :md="15" :lg="16" :xl="16" >
                                   <div>
                                       <h3>{{$t('acname.m28.c1')}}</h3>
                                       <p class="h5">{{$t('acname.m28.c2')}}</p>
                                       <p class="h5">{{$t('acname.m28.c3')}}</p>
                                       <p>{{$t('acname.m28.c4')}}</p>
                                       <p>{{$t('acname.m28.c5')}}</p>

                                       <p style="padding-right:30px">{{$t('acname.m28.c6')}}</p>
                                       <p>{{$t('acname.m28.c7')}}</p>
                                       <p>{{$t('acname.m28.c8')}}</p>
                                       <p style="padding-right:30px" class="h5">{{$t('acname.m28.c9')}}</p>
                                       <p>{{$t('acname.m28.c10')}}</p>
                                       <p>{{$t('acname.m28.c11')}}</p>
                                       <p>{{$t('acname.m28.c12')}}</p>
                                       <p>{{$t('acname.m28.c13')}}</p>
                                       <p style="padding-right:30px">{{$t('acname.m28.c14')}}</p>
                                       <p>{{$t('acname.m28.c15')}}</p>
                                       <p>{{$t('acname.m28.c16')}}</p>
                                   </div>
                                 </el-col>

                                <el-col style="background: #fff;" class="cont_box_col" v-show="parmaid == '8'" :xs="24" :sm="24" :md="15" :lg="16" :xl="16" >
                                    <div>
                                        <p style="text-align:center;">
                                            <img src="../../assets/img/logob.png" alt="" style='width:30%'>
                                        </p>
                                        <h3 style="text-align:center;">{{$t('acname.m8.c1')}}</h3>
                                        <p>{{$t('acname.m8.c2')}}</p>
                                        <p>{{$t('acname.m8.c3')}}</p>
                                        <p>{{$t('acname.m8.c4')}}</p>
                                        <p class="h4">{{$t('acname.m8.c5')}}</p>
                                        <p class="li_box"><i></i>{{$t('acname.m8.c6')}}</p>
                                        <p class="li_box"><i></i>{{$t('acname.m8.c7')}}</p>
                                        <p class="li_box"><i></i>{{$t('acname.m8.c8')}}</p>
                                        <p class="li_box"><i></i>{{$t('acname.m8.c9')}}</p>
                                        <p class="h4">{{$t('acname.m8.c10')}}</p>
                                        <p class="li_box"><i></i>{{$t('acname.m8.c11')}}</p>
                                        <p class="li_box"><i></i>{{$t('acname.m8.c12')}}</p>
                                        <p class="li_box"><i></i>{{$t('acname.m8.c13')}}</p>
                                        <p class="li_box"><i></i>{{$t('acname.m8.c14')}}</p>
                                        <p class="li_box"><i></i>{{$t('acname.m8.c15')}}</p>
                                        <p class="li_box"><i></i>{{$t('acname.m8.c16')}}</p>
                                        <p class="li_box"><i></i>{{$t('acname.m8.c17')}}</p>
                                        <p class="li_box"><i></i>{{$t('acname.m8.c18')}}</p>
                                        <p class="li_box"><i></i>{{$t('acname.m8.c19')}}</p>
                                        <p class="li_box"><i></i>{{$t('acname.m8.c20')}}</p>
                                        <p class="li_box"><i></i>{{$t('acname.m8.c21')}}</p>
                                        <p class="li_box"><i></i>{{$t('acname.m8.c22')}}</p>
                                        <p class="li_box"><i></i>{{$t('acname.m8.c23')}}</p>
                                        <p class="li_box"><i></i>{{$t('acname.m8.c24')}}</p>

                                        <p>{{$t('acname.m8.c25')}}</p>
                                        <p>{{$t('acname.m8.c26')}}</p>
                                        <p class="h4">{{$t('acname.m8.c27')}}</p>
                                        <p class="h4">{{$t('acname.m8.c28')}}</p>
                                        <p class="h4">{{$t('acname.m8.c29')}}</p>
                                        <p>{{$t('acname.m8.c30')}}</p>
                                    </div>
                                </el-col>



                                <div v-for="(item,index) in managementList" :key="index">
                                    <el-col style="background: #fff;" class="cont_box_col" v-show="parmaid == item.id" :xs="24" :sm="24" :md="15" :lg="16" :xl="16" >
                                        <div id="Jobs">
                                            <p style="text-align:center;">
                                                <img src="../../assets/img/logob.png" alt="" style='width:30%'>
                                            </p>
                                            <h3 style="text-align:center;" v-if="lang == 'en-US'">{{item.titleEn}}</h3>
                                            <h3 style="text-align:center;" v-if="lang == 'zh-CN'">{{item.titleZh}}</h3>
                                            <div id ="jobs">
                                                <div v-if="lang == 'en-US'"  v-html="item.textEn"></div>
                                                <div v-if="lang == 'zh-CN'" v-html="item.textZh"></div>
                                            </div>
                
                                            <p class="h4">{{$t('acname.m9.c27')}}</p>
                                            <p class="h4">{{$t('acname.m9.c28')}}</p>
                                            <p class="h4">Email:<a class="color_a" :href="'mailto:'+item.email">{{item.email}}</a></p>
                                            <p>{{$t('acname.m9.c30')}}</p>
                                        </div>
                                    </el-col>
                                </div>
                                

                            </el-row>

                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>

      <Footer :widthmun='windowWidth'/>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import Header from '@/components/Header/index.vue';
import Footer from '@/components/Footer/index.vue';
import report from '@/api/management.js'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {Header,Footer},
  data () {
  // 这里存放数据
    return {
        parmaid:'',
        activeName: '1',
        mename:'',
        activeclass:'',
        flag:'',
        flagipad:'',
        flagipadbool:'',
        managementList:[],
        lang:this.$i18n.locale,
        windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
        windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {
      windowHeight (val) {
        let that = this;
        
      },
      windowWidth (val) {
        let that = this;
        this.windowWidth = val
      },
      '$i18n.locale'(val) {
        this.lang = val
      },
      '$route.query.id'(val){
          if(val == 9){
              this.getlist()
          }
      }
  },
  // 方法集合
  methods: {
      gotopath(id){
          this.mename = this.$t('acname.mename7')
          this.parmaid = id;
          this.activeclass = id;
      },
      changemenu(name,id){
          console.log(123,this.mename)

          this.mename = '';
          this.mename = name;
          this.parmaid = id;
          this.activeclass = id;
      },
      changemenus(row){
        this.mename = '';
        if(this.lang == 'en-US'){
            this.mename = row.titleEn;
        }else{
            this.mename = row.titleZh;
        }
        this.activeName = '2'
        this.parmaid = row.id;
        this.activeclass = row.id;
      },
      isMobile() {
            this.flagipad = '';
            this.flagipadbool = ''
            this.flag = navigator.userAgent.match(
                /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
            );
            // console.log(333,this.flag);
            if(this.flag === null) {
                console.log("pc端");
                this.flagipadbool = '1'
            }else {
                this.flagipad =  this.flag[0];
                this.flagipadbool = '0'
                if(this.flagipad == "iPad"){
                    this.flagipadbool = '1'
                    // alert(this.windowWidth+'---'+this.flagipadbool)
                }
                console.log("移动端");
            }
      },
      changetype(){
            this.mename = '';
            if(this.parmaid == '1-1'){
                this.mename = this.$t('acname.mename1')
                this.activeName = '1'
                this.changemenu(this.mename,this.parmaid)
            }else if(this.parmaid == '2-1'){
                this.mename = this.$t('acname.mename2')
                this.activeName = '1'
                this.changemenu(this.mename,this.parmaid)
            }else if(this.parmaid == '3-1'){
                this.mename = this.$t('acname.mename3')
                this.activeName = '1'
                this.changemenu(this.mename,this.parmaid)
            }else if(this.parmaid == '4-1'){
                this.mename = this.$t('acname.mename4')
                this.activeName = '1'
                this.changemenu(this.mename,this.parmaid)
            }else if(this.parmaid == '5-1'){
                this.mename = this.$t('acname.mename5')
                this.activeName = '1'
                this.changemenu(this.mename,this.parmaid)
            }else if(this.parmaid == '6-1'){
                this.mename = this.$t('acname.mename6')
                this.activeName = '1'
                this.changemenu(this.mename,this.parmaid)
            }else if(this.parmaid == '7-1'){
                this.mename = this.$t('acname.mename7')
                this.activeName = '1'
                this.changemenu(this.mename,this.parmaid)
            }else if(this.parmaid == '9'){
                this.mename = this.$t('acname.mename9')
                this.activeName = '2'
                this.changemenu(this.mename,this.parmaid)
            }
      },
      getlist(){
            this.managementList = []
            let data = {'debug':2}
            if(window.location.origin.indexOf('mock') != -1){
                data = {'debug':1}
            }
            report.getActiveList(response =>{
                if(response.list && response.list.length >= 0){
                    this.managementList = response.list
                    if(this.$route.query.id == 9){
                        this.parmaid = response.list[0].id
                        this.activeclass = response.list[0].id
                        if(this.lang == 'en-US'){
                            this.mename = response.list[0].titleEn;
                        }else{
                            this.mename = response.list[0].titleZh;
                        }
                    }
                    
                }
            },data)
            let a = document.getElementById('22222')
            console.log(a)
      }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
        
      
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
        this.parmaid = this.$route.query.id;
        this.$bus.$on('changeid', (id) =>{
            this.parmaid = id;
            this.changetype()
        })
        this.changetype()
        this.isMobile();
        this.getlist()
        window.onresize = () => {
            return (() => {
                window.fullHeight = document.documentElement.clientHeight;
                window.fullWidth = document.documentElement.clientWidth;
                this.windowHeight = window.fullHeight;  // 高
                this.windowWidth = window.fullWidth; // 宽
            })()
        }
      
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss'>
#jobs ul li{
    display: flex;
    font-family:"Roboto", sans-serif;
    font-size:16px;
    line-height: 27px;
    i:after {
        content: url(../../assets/img/i1.png);
        margin-right: 9px;
    }
}
</style>
<style lang='scss' scoped>
// @import url(); 引入公共css类
.new_box{
    height:420px;
    background: url('../../assets/img/btcbj.png') no-repeat;
    background-size: cover;
    font-size:16px;
    color:#7d91aa;
}
::v-deep .el-breadcrumb__inner{
        color:#C8C8C8 !important;
        font-size:16px !important;
    }
.sp{
    padding-top:90px;
    padding-bottom:90px;
    .el-row{
        margin-top:10%;
    }
    .col_list{
        padding:10px;
        margin-bottom:20px;
    }
}
.showtitle {
    color: #fff!important;
    line-height: 50px;
    font-size:40px;
}

.span_box{
    font-weight:bold;
    color:#000;
}

.content{
    margin-top:-35px;
    min-height:700px;
    
    
    .cont_box{
        padding:20px;
        .el-row{
            margin-top:-20px;
        }
    }
    .h5{
        font-size:19px;
        font-family:inherit;
    }
    h6{
        font-size:14px;
        margin-bottom:25px;
        font-weight: normal;
    }
    p{
        margin-top:0;
        margin-bottom:16px;
        font-size:16px;
        line-height: 26px;
        font-family: ArialMT;
    }
    .new_box_list{
        padding-top:10px;
        padding-bottom:20px;
    }
}

.el-col-box{
    border:0.1px solid #fff;
    border-radius: 5px;
    margin-right:30px;
    box-shadow: 0px 5px 15px rgba(136,136,136,0.2);
}
::v-deep .el-collapse-item__header{
    padding-left:30px;
    font-weight:700;
    font-size:14px;
    color:#21212A;
    transition:all 0.4s ease;
    -webkit-transition:all 0.4s ease;
}
::v-deep .el-collapse-item__header:focus{
    background: #218CBA;
    color:#fff;
}
::v-deep .el-collapse-item__header:focus, .el-collapse, .el-col-box{
    border:none !important;
}
::v-deep .el-collapse-item__content{
    padding-left:30px;
    padding-right:20px;
    padding-top:10px;
    padding-bottom:10px;
    background: #EDEEF3;
    p{
        width:100%;
        font-size:12px;
        white-space: normal;
        margin:0;
        line-height: 35px;
        transition:all 0.25s ease;
        -webkit-transition:all 0.25s ease;
        color:#5D5D5D;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis !important;
        white-space: nowrap;
        text-decoration: none;
    }
    .el-link{
        width:100%;
        font-size:12px;
        white-space: normal;
        line-height: 35px;
        transition:all 0.25s ease;
        -webkit-transition:all 0.25s ease;
        color:#5D5D5D;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis !important;
        white-space: nowrap;
        text-decoration: none;
    }
    p:hover{
        color:#218CBA !important;
    }
    .el-link:hover{
        color:#218CBA !important;
    }
    .active{
        color:#218CBA !important;
    }
}
::v-deep .activeheader{
    .el-collapse-item__header{
        background: #218CBA;
        color:#fff;
    }
}
.cont_box_col{
    transition:all 0.4s ease;
    -webkit-transition:all 0.4s ease;
    padding:30px 20px 20px 20px;
    h3{
        color:#218CBA!important;
        margin:28px 0;
        font-size:32px;
        line-height: 42px;
        font-family: Arial-BoldMT, Arial;
        letter-spacing:2px;
        padding:10px 0 10px 0;
        font-weight: normal;
    }
    .h5{
        color:#21212a !important;
        font-size:20px;
        line-height: 30px;
        letter-spacing:1px;
        padding-top:10px;
        padding-bottom:10px;
        font-weight: 800;
    }
    .h4{
        font-weight:800;
        font-family:"Roboto", sans-serif;
        font-size:18px;
        line-height: 28px;
    }
}
.icon_box{
    padding:30px 30px 30px 10px;
    p{
        padding-top:10px;
        padding-left:20px;
    }
}
.li_box{
    display: flex;
    font-family:"Roboto", sans-serif;
    font-size:16px;
    line-height: 27px;
    i:after {
        content: url(../../assets/img/i1.png);
        margin-right: 9px;
    }
}
.color_p{
    color:#218CBA;
}
.hp{
    color:#21212A;
    font-weight:800;
    font-family:"Roboto", sans-serif;
    font-size:16px;
    line-height: 27px;
}
i.vision:after {
    content: url(../../assets/img/vision.png);
}

i.mission:after {
    content: url(../../assets/img/mission.png);
}

.ac3_box{
    padding:20px 0 20px 0;
    img{
        padding-top:10px;
    }
    p{
        padding:0;
        padding-bottom:10px;
        margin:0;
    }
    .h5{
        padding:0;
        padding-top:10px;
    }
}


#Jobs Ul li{
    
}

#Jobs Ul li:after{
    content: url(../../assets/img/i1.png);
}
@media screen and (min-width: 280px) and (max-width: 1023px) {
    /deep/.el-collapse-item__header{
        font-size:24px !important;
        height: 80px;
    }
    /deep/.el-collapse-item__content .el-link{
        font-size:24px !important;
        line-height: 60px;
    }
    /deep/.el-collapse-item__content p{
        font-size:24px !important;
        line-height: 60px;
    }
}
</style>
